import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ThemeService } from '../../../services/theme.service';
import { fadeInAnimation } from '@shared/animations';

@Component({
  selector: 'app-icam-container',
  templateUrl: './icam-container.component.html',
  styleUrl: './icam-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInAnimation]
})
export class IcamContainerComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);

  isLight?: boolean | undefined;
  isVisible = true;
  isExpanded = false;

  @Input() iconName!: string;
  @Input() iconColor!: string;
  @Input() iconHeight?: string;
  @Input() isClosable = false;
  @Input() centralIcon = false;
  @Input() fixedTheme: 'dark' | 'light' | null = null;
  @Input() isExpandable = false;
  @Output() toggleShow = new EventEmitter();

  ngOnInit() {
    if (!this.fixedTheme) {
      this._themeService.isLight$
        .pipe(
          takeUntilDestroyed(this._destroyRef),
          tap((x) => {
            this.isLight = x;
            this._cdr.markForCheck();
          })
        )
        .subscribe();
    } else {
      this.isLight = this.fixedTheme === 'light';
    }
  }

  closeContainer() {
    this.isVisible = false;
    this._cdr.markForCheck();
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
    this.toggleShow.emit();
    this._cdr.markForCheck();
  }
}
